import { Role, VisitorGroupMembership } from 'graphql/generated/graphqlTypes';
import { generateMockVisitorGroup } from './visitorGroup';

export function generateMockVisitorGroupMembership({
  role = Role.ExternalGroupUserManager,
  visitorGroup = generateMockVisitorGroup({}),
  expirationDate = null
}: Partial<Omit<VisitorGroupMembership, '__typename'>>): VisitorGroupMembership {
  return {
    __typename: 'VisitorGroupMembership',
    role,
    visitorGroup,
    expirationDate
  };
}
